import React from "react";
import BookContainer from "./BookContainer";
import BookFilter from "./BookFilter";
import BookForm from "./BookForm";

const BookShow = () => {
  return (
    <>
      <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
        <div className="order-2 xl:-order-1">
          <BookFilter />
          <BookContainer />
        </div>
        <BookForm />
      </div>
    </>
  );
};

export default BookShow;
